module.exports = __webpack_public_path__ + "static/service-1-4c01de4ba5e41d4e56f706d44874c98e.svg";